import React from 'react';

import { useIntl } from 'react-intl';

import ConfirmDialog from 'components/confirm-dialog';

import { logCTAEvent } from '../../utils';
import { BodyComponent } from '../body-component';

interface IUnsavedChangesDialog {
  showDialog: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const UnsavedChangesDialog = ({
  showDialog,
  onConfirm,
  onCancel,
}: IUnsavedChangesDialog) => {
  const { formatMessage } = useIntl();

  const heading = formatMessage({ id: 'unsavedChangesModalHeader' });
  const content = formatMessage({ id: 'unsavedChangesModalDescription' });

  const saveLabel = formatMessage({ id: 'saveChanges' });
  const discardLabel = formatMessage({ id: 'leaveWithoutSaving' });

  return showDialog ? (
    <ConfirmDialog
      showDialog={showDialog}
      modalAppearanceEventMessage="Confirmation: Product Wizard - Discard Unsaved Changes"
      bodyComponent={<BodyComponent heading={heading} content={content} />}
      confirmLabel={saveLabel}
      cancelLabel={discardLabel}
      onConfirm={() => {
        logCTAEvent(saveLabel);
        onConfirm();
      }}
      onCancel={() => {
        logCTAEvent(discardLabel);
        onCancel();
      }}
    />
  ) : null;
};
